import { render } from "./Waiting4.vue?vue&type=template&id=252e6677"
import script from "./Waiting4.vue?vue&type=script&lang=js"
export * from "./Waiting4.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__